import React from "react";
import { useParams, Navigate } from "react-router-dom";
import PublicidadRegistro from "./PublicidadRegistro";
import PublicidadCalculo from "./PublicidadCalculo";
import PublicidadClasificador from "./PublicidadClasificador";
import PublicidadClasificadorImpuestos from "./PublicidadClasificadorImpuestos";
import SolvenciaPublicidad from "./SolvenciaPublicidad";

const PublicidadPage = () => {
  const { submodulo } = useParams();

  if (!submodulo) return <Navigate to="/publicidad/registro" replace />;

  switch (submodulo) {
    case "registro": return <PublicidadRegistro />;
    case "calculo": return <PublicidadCalculo />;
    case "solvencia-publicidad": return <SolvenciaPublicidad />;
    case "clasificador": return <PublicidadClasificador />;
    case "clasificador-impuestos": return <PublicidadClasificadorImpuestos />;
    default: return <Navigate to="/publicidad/registro" replace />;
  }
};

export default PublicidadPage;
